<template>
    <span>
        <i class="fas fa-circle-notch fa-spin" style="font-size: 16px;"></i>
    </span>
</template>

<script>
export default {
  name: 'LoadingWheel'
};
</script>